__turbopack_context__.v({
  "fadeOut": "BQ_ifa_fadeOut",
  "fieldCompletedIndicator": "BQ_ifa_fieldCompletedIndicator",
  "fieldContainer": "BQ_ifa_fieldContainer",
  "fieldData": "BQ_ifa_fieldData",
  "fieldIcon": "BQ_ifa_fieldIcon",
  "fieldLeftContent": "BQ_ifa_fieldLeftContent",
  "highlighted": "BQ_ifa_highlighted",
});
